<template>
  <div class="list-filter">
    <div class="list-filter__input-text">
      <TutorListFilterText />
      <TutorListFilterInput class="mt-8 lg:mt-0" />
    </div>
    <TutorListFilterImg class="order-1 lg:order-2" />
  </div>
</template>
<script>
import TutorListFilterText from '@/components/pages/tutor-list/filter/filter-text.vue'
import TutorListFilterInput from '@/components/pages/tutor-list/filter/filter-input/filter-input.vue'
import TutorListFilterImg from '@/components/pages/tutor-list/filter/filter-img.vue'

export default {
  name: 'TutorListFilter',
  components: { TutorListFilterImg, TutorListFilterInput, TutorListFilterText }
}
</script>

<style scoped lang="scss">
.list-filter {
  @apply container flex justify-between flex-col lg:flex-row;
  &__input-text {
    @apply flex flex-col justify-between order-2 lg:order-1 mt-6 lg:mt-0;
  }
}
</style>
